import styled, { css } from 'styled-components';

interface ShimmerVariantsProps {
  type?: 'card';
}

export const ShimmerVariants = styled.div<ShimmerVariantsProps>`
  ${({ type }) =>
    type === 'card' &&
    css`
      height: 274px;
    `}

  width: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
`;
